<template>
  <div class="access">
    <el-row type="flex" justify="space-around" align="center">
      <el-col :span="6"></el-col>
      <el-col :span="12">
        <el-form size="large" :model="form" class="demo-form-inline">
          <el-form-item label="车牌号">
            <el-input v-model="form.plateNumber"></el-input>
          </el-form-item>
          <el-form-item label="车牌颜色">
            <el-select v-model="form.plateColor" placeholder="请选择车牌颜色" style="width: 100%;">
              <el-option label="蓝色" value="1"></el-option>
              <el-option label="黄色" value="2"></el-option>
              <el-option label="黄绿色" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {}
      }
    },
    methods: {
      search() {
        this.searchloading = true;
        this.$global.axios.post(this, '/sywl/api/locus/visCar', this.form, res => {
          this.$alert(typeof res.data === 'string' ? `入网时间：${res.data}` : '未查询到入网信息', '查询结果')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .access {
    padding: 330px 16px;
    background-color: #fff;

    & /deep/ .el-button {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/access.vue